// LIBRERIE/IMPORTS
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface Agent {
    img: string;
    name: string;
    tel?: string;
    mobile?: string;
    email?: string;
}

interface AgentsSectionProps {
    showAgents: boolean;
    agents: Agent[];
    agentsLoading: boolean;
    agentsError: string | null;
}

const AgentsSection: React.FC<AgentsSectionProps> = ({ showAgents, agents, agentsLoading, agentsError }) => {
    const { t } = useTranslation();

    const [activeIndex, setActiveIndex] = useState(0);
    const agentCount = agents.length;

    // Carosello x agenti
    useEffect(() => {
        const interval = setInterval(() => {
            changeAgent();
        }, 5000);

        function changeAgent() {
            setActiveIndex(prev => (prev >= agentCount - 1 ? 0 : prev + 1));
        }

        return () => clearInterval(interval);
    }, [agentCount]);

    if (!showAgents) return null;

    // Inserisce l'img di default quando nel DB è null
    agents.forEach((agent) => {
        if(agent.img == null){
            agent.img = "/assets/images/logo.png";
        }
    })

    return (
        (agentsLoading || agentsError || agents.length > 0) ? (
            <section className="agent-widget">
                <div>
                    {agentsLoading ? (
                        <div className="text-center">{t('agents.loadingAgents')}...</div>
                    ) : agentsError ? (
                        <div className="text-center text-danger">{agentsError}</div>
                    ) : (
                        <div className="row no-gutters justify-content-center">
                            <h2>{t('agents.sectionTitle')}</h2>
                            {agents.map((agent, index) => (
                                <div 
                                key={index} 
                                className={`agent-card ${index == activeIndex ? "" : "d-none"}`} 
                                style={{backgroundImage: `url(${agent.img})`, backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat"}}
                                >
                                    <div className="w-100 text-center bg-overlay-black-30">
                                        <p className="my-2">{agent.name}</p>
                                        <div className="mb-3">
                                            <a href={`tel:${agent.tel}`}>{agent.tel}</a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>
        ) : null
    );
};

export default AgentsSection;